//* API Docs url
export const API_FOR_PROD = 'https://api.textback.ai';
export const API_FOR_BETA = 'https://apibeta.textback.ai';
export const API_FOR_STG = 'https://stgapi.textback.ai';

//* API KYC
export const ADD_DOCUMENT_URL = '/tb/api/v2/authenticated/kyc/addInformation';
export const REMOVE_DOCUMENT_URL = '/tb/api/v2/authenticated/kyc/removeDocument';
export const DETAILS_KYC_URL = '/tb/api/v2/authenticated/kyc/details';
export const ADD_INFORMATION_KYC_URL = '/tb/api/v2/authenticated/kyc/addInformation';
export const SUBMIT_KYC_URL = '/tb/api/v2/authenticated/kyc/submit';

//* API TESTING
export const AI_TESTING_URL = '/tb/api/v2/authenticated/user/aiTesting';
export const CAMPAIGN_STATS_URL = '/tb/api/v2/authenticated/campaign/stats';
export const EXPORT_CAMPAIGN_STATS_URL = '/tb/api/v2/authenticated/campaign/stats';

//* PREMIUM ORDER
export const LIST_ORDER_URL = '/tb/api/v2/authenticated/premium/list-order';
export const CREATE_ORDER_URL = '/tb/api/v2/authenticated/premium/create-order';
export const CHECK_ORDER_URL = '/tb/api/v2/authenticated/premium/check-credit';

export const SYNONYM_URL = '/tb/api/v2/authenticated/user/find-synonym';
export const LOGIN_URL = '/tb/login';
export const LOGOUT_URL = '/tb/api/v2/authenticated/user/logout';
export const BALANCE_URL = '/tb/api/v2/authenticated/user/getBalance';
export const USER_SERVLET_URL = '/tb/userServlet';
export const MANAGE_CONTACTS_SERVLET_URL = '/tb/manageContactsServlet';
export const AUTO_REPLIES_SERVLET_URL = '/tb/autoRepliesServlet'; // NOTED
export const SEND_SERVLET_URL = '/tb/sendServlet';
export const STATS_SERVLET_URL = '/tb/statsServlet';
export const MANAGE_USERS_URL = '/tb/manageUsersServlet';
export const CHECK_SPELL_URL = '/tb/spellcheck';
export const VERIFY_URL = '/tb/api/v2/authenticated/send/verifyUrl';
export const INBOX_URL = '/tb/inboxServlet';
export const AVAILABLE_COUNTRIES_URL = '/tb/api/v2/authenticated/number/availableCountries';
export const LOAD_CONFIG_URL = '/tb/api/v2/authenticated/dialog/loadDialogConfig';
export const CONTACT_URL = '/tb/api/v2/authenticated/contact';
// What was actually sent to one of the caller's own contacts (cloud-webapp SmsSentResource, TEX-296).
export const SMS_SENT_URL = '/tb/api/v2/authenticated/sms/sent';
export const CARRIER_URL = '/tb/api/v2/authenticated/contact/loadCarrierList';
export const CONTACT_GROUP_LEAD_CALLBACK_URL =
  '/tb/api/v2/authenticated/contact/contactGroupLeadCallback';
export const EXPORT_URL = '/tb/exportServlet'; // NOTED
export const VOLUUM_URL = '/tb/api/v2/authenticated/voluum';
export const MOVE_CREDIT_URL = '/tb/api/v2/authenticated/user/move-credit';

// Inbox v2
export const INBOX_V2_URL = '/tb/api/v2/authenticated/inbox';
export const INBOX_V2_MESSAGES_URL = '/tb/api/v2/authenticated/inbox/messages';
export const INBOX_V2_MESSAGES_DELETE_URL =
  '/tb/api/v2/authenticated/inbox/messages/deleteByThread';
export const INBOX_V2_THREADS_URL = '/tb/api/v2/authenticated/inbox/threads';

export const CREATE_CONTACT_FILTER_TASK_URL =
  '/tb/api/v2/authenticated/contact/createContactFilterTask';
export const GET_RUNNING_CONTACT_FILTER_TASK_URL =
  '/tb/api/v2/authenticated/contact/getRunningContactFilterTask';
export const GET_ALL_RUNNING_CONTACT_FILTER_TASK_URL =
  '/tb/api/v2/authenticated/contact/getAllContactFilterTask';
export const STOP_CONTACT_FILTER_TASK_URL =
  '/tb/api/v2/authenticated/contact/stopContactFilterTask';
export const RESUME_CONTACT_FILTER_TASK_URL =
  '/tb/api/v2/authenticated/contact/startContactFilterTask';
export const DELETE_CONTACT_FILTER_TASK_URL =
  '/tb/api/v2/authenticated/contact/deleteContactFilterTask';

//* DID GROUP
export const GET_ALL_INACTIVE_DOMAIN_URL = '/tb/api/v2/authenticated/domain/getAllInActiveDomain';
export const FLUSH_CONVERSATION_URL = '/tb/api/v2/authenticated/dialog/flushDialogContext';
export const FLUSH_DOMAIN = '/tb/api/v2/authenticated/domain/flushRecentPerformance';
export const FLUSH_DID = '/tb/api/v2/authenticated/number/flushRecentPerformance';
export const LOAD_DIALOG_URL = '/tb/api/v2/authenticated/dialog/loadDialogs';
export const LOAD_DIALOG_DETAIL_URL = '/tb/api/v2/authenticated/dialog/loadDialogContent';
export const SAVE_DIALOG_URL = '/tb/api/v2/authenticated/dialog/saveDialog';
export const DELETE_DIALOG_URL = '/tb/api/v2/authenticated/dialog/deleteDialog';
export const SAVE_DIALOG_CONTENT_URL = '/tb/api/v2/authenticated/dialog/saveDialogContent';
export const DELETE_DIALOG_CONTENT_URL = '/tb/api/v2/authenticated/dialog/deleteDialogContent';
export const SOFT_DELETE_DIALOG_CONTENT_URL = '/tb/api/v2/authenticated/dialog/softDelete';

export const ADMIN_SERVLET_URL = '/tb/adminServlet'; // NOTED
export const CHECK_EMAIL = '/tb/api/v2/public/user/checkEmail';
export const CHANGE_EMAIL = '/tb/api/v2/authenticated/user/changeEmail';
export const FORMAT_NUMBER_FREE_URL = '/tb/api/v2/public/number/formatNumberFree';
export const PRICE_TABLE_URL = '/tb/api/v2/authenticated/user/loadPriceTable';
export const STATS_URL = '/tb/api/v2/authenticated/user/me/stats';
export const CARRIER_STATS_URL = '/tb/api/v2/authenticated/user/me/carrier-stats';
export const CHECK_SPAM_SCORE_URL = '/tb/api/v2/authenticated/user/checkSpamscore';
export const GET_STATS_DIALOG_URL = '/tb/api/v2/authenticated/dialog/getStats';

export const RESET_DID_CYCLE_IN_GROUP_URL = '/tb/api/v2/authenticated/number/resetDIDsCycleInGroup';

export const RELEASE_DID_NOW_BY_CLICK_RATE_URL =
  '/tb/api/v2/authenticated/number/releaseDidNowByClickRate';
export const RELEASE_DID_NOW_BY_DELIVERY_RATE_URL =
  '/tb/api/v2/authenticated/number/releaseDidNowByDeliveryRate';
export const LOAD_DID_GROUPS_URL = '/tb/api/v2/authenticated/number/loadDidGroups';
export const LOAD_DID_IN_GROUPS_URL = '/tb/api/v2/authenticated/number/loadDidInGroup';
export const TOTAL_DID_IN_GROUPS_URL = '/tb/api/v2/authenticated/number/totalDidInGroup';
export const CREATE_DID_GROUP_URL = '/tb/api/v2/authenticated/number/createDidGroup';
export const DELETE_DID_GROUP_URL = '/tb/api/v2/authenticated/number/deleteDidGroup';
export const MERGE_DID_GROUPS_URL = '/tb/api/v2/authenticated/number/mergeGroup';
export const SPLIT_DID_GROUP_URL = '/tb/api/v2/authenticated/number/splitGroup';
export const TOTAL_DID_IN_ACCOUNT_URL = '/tb/api/v2/authenticated/number/totalDidInAccount';
export const AVAILABLE_PHONE_NUMBER_URL = '/tb/api/v2/authenticated/number/availablePhoneNumbers';
export const MOVE_DID_URL = '/tb/api/v2/authenticated/number/moveDid';
export const BULK_PURCHASE_URL = '/tb/api/v2/authenticated/number/bulkPurchase';
export const DELETE_SINGLE_DID_URL = '/tb/api/v2/authenticated/number/deleteSingleDid';
export const SAVE_DID_URL = '/tb/api/v2/authenticated/number/saveDidGroup';
export const GET_COUNTRY_CODE_URL = '/tb/api/v2/authenticated/number/getDidGroupCountryCodes';
export const LOAD_DID_STATS = '/tb/api/v2/authenticated/number/loadDidGroupStats';
export const RELEASE_DID_NOW_URL = '/tb/api/v2/authenticated/number/releaseDidNow';

//* Contact
export const MERGE_GROUPS_URL = '/tb/api/v2/authenticated/contact/mergeGroups';
export const SPLIT_GROUP_URL = '/tb/api/v2/authenticated/contact/splitGroup';
export const START_LINE_CHECK_URL = '/tb/api/v2/authenticated/contact/startLineLineCheck';
export const GET_ALL_RUNNING_LANDLINE_CHECK_URL =
  '/tb/api/v2/authenticated/contact/getAllRunningLandLineCheck';
export const GET_LANDLINE_CHECK_STATUS_URL =
  '/tb/api/v2/authenticated/contact/getLandLineCheckStatus';
export const CANCEL_LANDLINE_URL = '/tb/api/v2/authenticated/contact/cancelLandLineCheck';
export const GET_ALL_RUNNING_CONTACT_IMPORT_URL =
  '/tb/api/v2/authenticated/contact/getAllRunningContactImport';
export const IMPORT_FILE_STATUS_URL = '/tb/api/v2/authenticated/contact/importFileStatus';
export const EXPORT_CONTACT_URL = '/tb/exportServlet'; // NOTED
export const IMPORT_CONTACT_GROUP_URL = '/tb/userServlet'; // NOTED
export const EXPORT_DID_URL = '/tb/api/v2/authenticated/number/export-dids';
export const EXPORT_READFILE_URL = '/tb/readFile'; // NOTED
export const DELETE_PREVIEW_FILE_URL = '/tb/api/v2/authenticated/contact/deleteFile';
export const IMPORT_FROM_STORAGE_URL = '/tb/api/v2/authenticated/contact/importFromStorage';
export const CANCEL_IMPORT_URL = '/tb/api/v2/authenticated/contact/cancelImport';
export const PREVIEW_LINE_URL = '/tb/api/v2/authenticated/contact/getPreviewLines';
export const UPLOAD_CONTACT_URL = '/tb/api/v2/authenticated/contact/uploadFileToStorage';
export const GET_PURCHASE_PROCESS_URL = '/tb/api/v2/authenticated/number/getPurchaseProcess';
export const CONTACT_GROUP_LEAD_FILTER_URL =
  '/tb/api/v2/authenticated/contact/contactGroupLeadFilter';
export const COUNT_CONTACT_GROUP_INTERACTION_URL =
  '/tb/api/v2/authenticated/contact/countContactInGroupByInteraction';
export const FILTER_SUPPRESSION_CONTACT_GROUP_URL =
  '/tb/api/v2/authenticated/contact/filterSuppressionGroups';

//* Special endpoint
export const DOWNLOAD_CALL_RECORDING_URL = '/tb/inboxServlet';
export const IMPORT_CONTACT_URL = '/tb/api/v2/authenticated/contact/importFile';
export const UPLOAD_DIALOG_FILE_URL = '/tb/api/v2/authenticated/dialog/uploadDialogFile';
export const GET_ROUTE_LIST_URL = '/tb/api/v2/admin/loadRouteList';
export const DELETE_DID_URL = '/tb/api/v2/admin/deleteDid';

//* Payment
export const ADD_CARD_URL = '/tb/api/v2/authenticated/user/addCard';
export const GET_LIST_CARD_URL = '/tb/api/v2/authenticated/user/listCard';
export const MAKE_DEFAULT_CARD_URL = '/tb/api/v2/authenticated/user/makeDefault';
export const DELETE_CARD_URL = '/tb/api/v2/authenticated/user/deleteCard';
export const GET_HISTORY_CHARGE_URL = '/tb/api/v2/authenticated/user/hisCharge';
export const SET_AUTO_RECHARGE_URL = '/tb/api/v2/authenticated/user/setAutoRecharge';
export const PURCHASE_CREDIT_URL = '/tb/api/v2/authenticated/user/purchaseCredit';
export const LOAD_CREDIT_PACKAGE = '/tb/api/v2/authenticated/user/loadCreditPackage';

//* Domain
export const GET_DOMAIN_URL = '/tb/api/v2/authenticated/domain';
export const CREATE_DOMAIN_URL = '/tb/api/v2/authenticated/domain/create';
export const UPDATE_DOMAIN_URL = '/tb/api/v2/authenticated/domain/update';
export const UPDATE_ALL_DOMAIN_URL = '/tb/api/v2/authenticated/domains/update/';
export const DELETE_DOMAIN_URL = '/tb/api/v2/authenticated/domain/delete/';
export const SEARCH_DOMAIN_URL = '/tb/api/v2/authenticated/domain/search';
export const FIND_DOMAIN_SIMILAR_URL = '/tb/api/v2/authenticated/domain/find-similar';
export const BUY_DOMAIN_URL = '/tb/api/v2/authenticated/domain/buy/';
export const SETUP_DOMAIN_URL = '/tb/api/v2/authenticated/domain/setup/';
export const SEARCH_DIALOGS_BY_DOMAIN =
  '/tb/api/v2/authenticated/dialog/searchDialogsByDomainGroupId';
export const BUY_BY_BATCH_URL = '/tb/api/v2/authenticated/domain/buyByBatch';
export const GET_BUYING_PROCESS_URL = '/tb/api/v2/authenticated/domain/getBuyingProcess';
export const DISMISS_BUYING_PROCESS_URL =
  '/tb/api/v2/authenticated/domain/dismissBuyingProcessNoti';

//* Creative
export const CREATIVE_URL = '/tb/api/v2/authenticated/creative';
export const CREATIVE_CAMPAIGN_URL = '/tb/api/v2/authenticated/campaign-creative';

//* Offer
export const OFFER_URL = '/tb/api/v2/authenticated/offer';
export const OFFER_CAMPAIGN_URL = '/tb/api/v2/authenticated/campaign-offer';

//* Notification
export const NOTIFICATION_URL = '/tb/api/v2/authenticated/notification';

//* Domain Group
export const DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group';
export const CREATE_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/create';
export const DELETE_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/delete';
export const GET_ALL_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/getAll';
export const SAVE_DOMAIN_GROUP_SETTING_URL =
  '/tb/api/v2/authenticated/domain-group/saveDomainGroupSetting';
export const MIGRATE_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/migrate';
export const LOAD_DOMAIN_IN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/loadDomainsInGroup';
export const RELEASE_DOMAIN_NOW = '/tb/api/v2/authenticated/domain-group/releaseDomainNow';
export const RELEASE_EACH_DOMAIN = '/tb/api/v2/authenticated/domain/release';
export const MERGE_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/merge';
export const SPLIT_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain-group/splitGroup';
export const RESET_DOMAIN_GROUP_URL = '/tb/api/v2/authenticated/domain/resetDomainsInGroup';

//* Report
export const SEND_REPORT = '/internal/api/report';
export const TRACKING_URL = '/tb/api/v2/authenticated/tracking';

//* Guide
export const GUIDE_URL = '/tb/api/v2/authenticated/guide/';
export const GUIDE_BY_ROLE_URL = '/tb/api/v2/admin/guide/';

//* Data consuming
export const START_DATA_CONSUMING_URL = '/tb/api/v2/authenticated/contact/startDataConsuming';
export const GET_DATA_CONSUMING_URL = '/tb/api/v2/authenticated/contact/getDataConsumingProcess';

//* Data refreshing
export const START_DATA_REFRESHING_URL = '/tb/api/v2/authenticated/contact/startDataRefreshing';
export const GET_DATA_REFRESHING_URL = '/tb/api/v2/authenticated/contact/getDataRefreshingProcess';

//* Tickets
export const TICKETS_URL = `/tb/api/v2/authenticated/tickets`;

//* Campaign
export const REFRESH_CAMPAIGN_URL = '/tb/api/v2/authenticated/campaign/refresh-campaign';

//* Authentication v2
export const V2_LOGIN_URL = '/tb/api/v2/authentication/login';
export const V2_LOGOUT_URL = '/tb/api/v2/authentication/logout';
export const V2_FORGOT_PASSWORD_URL = '/tb/api/v2/authentication/forgot-password';
export const V2_RESET_PASSWORD_URL = '/tb/api/v2/authentication/reset-password';
export const V2_CHANGE_PASSWORD_URL = '/tb/api/v2/authentication/change-password';
export const V2_MFA_STATUS_URL = '/tb/api/v2/authentication/mfa-status';

//* 10-DLC
export const BRAND_URL = '/tb/api/v2/authenticated/brand';
export const PROFILE_URL = '/tb/api/v2/authenticated/profile';
export const USE_CASE_URL = '/tb/api/v2/authenticated/usecase';
export const REQUEST_USE_CASE_URL = '/tb/api/v2/authenticated/request10dlc';
export const LOAD_10DLC_VENDOR_URL = '/tb/api/v2/authenticated/user/load10dlcVendorList';
export const USECASE_SENDER_URL = '/tb/api/v2/authenticated/usecase';

//* Attachment url
export const UPLOAD_ATTACHMENT_CREATIVE_URL = '/tb/api/v2/authenticated/creative/attachment/upload';
export const UPLOAD_ATTACHMENTS_CREATIVE_URL =
  '/tb/api/v2/authenticated/creative/attachment/upload/multiple';
export const UPLOAD_DELETE_URL = '/tb/api/v2/authenticated/creative/attachment/delete';
export const GET_ATTACHMENT_CREATIVE_URL = '/tb/api/v2/authenticated/creative/attachment/get';

//* Invoice url
export const BANK_TRANSFER_URL = '/tb/api/v2/authenticated/user/bank-transfer';
export const UPLOAD_PROOF_BANK_URL = '/tb/api/v2/authenticated/user/bank-transfer/pop/upload';
export const DOWNLOAD_PROOF_URL = '/tb/api/v2/authenticated/user/bank-transfer/pop/download';
export const DOWNLOAD_INVOICE_URL = '/tb/api/v2/authenticated/user/invoice/download';
export const DOWNLOAD_CREDIT_INVOICE_URL = '/tb/api/v2/authenticated/user/invoice/downloadcredinv';

//* BACKGROUND_PROCESS
export const BACKGROUND_PROCESS_URL = '/tb/api/v2/authenticated/user/generic-background-task';

//* Version Managment
export const LISTALL_CAROUSEL_URL = '/tb/api/v2/authenticated/carousel/listAll';
export const CAROUSEL_MEDIA_ID_URL = '/tb/api/v2/authenticated/carousel/media';
export const CAROUSEL_URL = '/tb/api/v2/authenticated/carousel';

export const FIND_PHONE_URL = '/tb/api/v2/authenticated/contact/findPhone';

export const TRAFFIC_URL = '/tb/api/v2/authenticated/traffic/';

export const ERROR_STATS = '/tb/api/v2/authenticated/statistic/error';
export const GET_FULL_VENDOR_LIST = '/tb/api/v2/authenticated/user/loadFullVendorList';

//* Creative Assistant
export const CREATIVE_ASSISTANT_URL = '/tb/api/v2/authenticated/creative/assistant';

//* Media storage URL
export const MEDIA_STORAGE_URL = '/tb/api/v2/authenticated/media';
export const MEDIA_CAMPAIGN_URL = '/tb/api/v2/authenticated/campaign-media';

//* Audio Builder
export const AUDIO_BUILDER_URL = '/tb/api/v2/authenticated/media/audio-builder';

//* TFN
export const TOLL_FREE_URL = '/tb/api/v2/authenticated/tfn';

//* Referral
export const REFERAL_URL = '/tb/api/v2/authenticated/referral';

//* Landing page
export const LANDING_PAGE_URL = '/tb/api/v2/landingPage';

//* Package
export const API_PACKAGE_URL = '/tb/api/v2/authenticated/api_package';

//* Original authenticated
export const AUTHENTICATED_URL = '/tb/api/v2/authenticated';

export const ERROR_LIST_OPTIONS_URL = '/tb/api/v2/authenticated/user/error/enums';
